import React from 'react'
import { PlatformIdentityContext } from '../../providers/platform-identity-provider/platform-identity-provider'
import { buildAuthorizeRoute } from '../../_utils/routing'
import randomstring from 'randomstring'
import { AUTH0_STATE_SESSION_KEY, AUTH_REDIRECT_PARAM } from '../../constants'
import { useLocation } from 'react-router-dom'
import { PlatformUserContext } from '../../providers/user-provider/user-provider'
import { useService } from '@pushly/aqe/lib/hooks'
import { SessionState } from '@pushly/aqe'
import { AuthService } from '../../services'

export type PushlyAuth0State = {
    ts: number
    redirectURL?: string
}

export const Auth0Redirect = () => {
    const idpContext = React.useContext(PlatformIdentityContext)
    const sessionState = useService(SessionState)
    const loc = useLocation()
    const params = new URLSearchParams(loc.search)
    const authSvc = useService(AuthService)

    if (idpContext.loaded && !sessionState.isAuthenticated) {
        const label = idpContext.whiteLabelSettings
        const authorizeRoute = buildAuthorizeRoute(label?.getAuth0HostedLoginDomain()!, true)
        const clientId = label.getAuth0PlatformClientId() ?? 'g9Cd1SD4Tj0df4lQaF3KJT1PLLZsNktq'
        const audience = label.getAuth0AudienceName()
        const redirectURI = buildAuthorizeRoute(label.getHostname())

        const stateRecord: PushlyAuth0State = {
            ts: new Date().getTime(),
        }

        if (params.has(AUTH_REDIRECT_PARAM)) {
            const redirectURL = params.get(AUTH_REDIRECT_PARAM)!
            if (!/^\/authorize/.test(redirectURL)) {
                stateRecord.redirectURL = redirectURL
            }
        }
        const state = btoa(JSON.stringify(stateRecord))

        // consider using JWT
        window.sessionStorage.setItem(AUTH0_STATE_SESSION_KEY, state)

        // possible params from auth0 invitation link
        const auth0Params = new URL(window.location.toString()).searchParams
        let invitationId: string | null = null
        let orgId: string | null = null
        let orgName: string | null = null

        if (auth0Params) {
            invitationId = auth0Params.get('invitation')
            orgId = auth0Params.get('organization')
            orgName = auth0Params.get('organization_name')
        }

        if (!window.location.pathname.includes('authorize')) {
            const redirectURL = [
                `${authorizeRoute}?response_type=code`,
                `client_id=${clientId}`,
                `audience=${audience}`,
                `redirect_uri=${redirectURI}`,
                'scope=profile%20email%20offline_access',
                `state=${state}`,
            ]

            if (invitationId && orgId && orgName) {
                redirectURL.push(`invitation=${invitationId}`, `organization=${orgId}`, `organization_name=${orgName}`)
            }

            window.location.href = redirectURL.join('&')
        }
    } else {
        authSvc.logout(sessionState.sessionExpired)
    }

    return null
}
